// Adaptive Fauna theme — small, dependency-free behaviors

document.addEventListener('DOMContentLoaded', () => {
  // Mobile nav toggle
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Variant select → update price + form variant id
  document.querySelectorAll('[data-product-form]').forEach((wrapper) => {
    const select = wrapper.querySelector('[data-variant-select]');
    const idInput = wrapper.querySelector('input[name="id"]');
    const priceEl = wrapper.querySelector('[data-product-price]');
    const buyBtn = wrapper.querySelector('[data-add-to-cart]');
    if (!select) return;
    select.addEventListener('change', () => {
      const opt = select.selectedOptions[0];
      if (idInput) idInput.value = opt.value;
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (buyBtn) {
        const available = opt.dataset.available === 'true';
        buyBtn.disabled = !available;
        buyBtn.textContent = available ? buyBtn.dataset.labelAdd : buyBtn.dataset.labelSoldOut;
      }
    });
  });
});
